'use client';

import { useCallback } from 'react';

/**
 * Hook to format pie chart labels based on value threshold.
 * For large values (>= threshold), shows just the percentage.
 * For small values (< threshold), shows name and percentage.
 */
export function useFormatLabel(percent: number, smallValueThreshold: number) {
  const formatLabel = useCallback(
    (labelName: string, labelValue: number): string => {
      if (percent >= smallValueThreshold) {
        // For large values, show just the percentage
        return `${labelValue.toFixed(2)}%`;
      }
      // For small values, show name and percentage
      return `${labelName}: ${labelValue.toFixed(2)}%`;
    },
    [percent, smallValueThreshold]
  );

  return formatLabel;
}
